export default "__VITE_ASSET__CzoY6fBS__"